import React, { useEffect, useState } from 'react';
import { MultiCombobox } from '../combobox';
import { TeamSupportDto } from '@api/ChallengeClient';
import { injectTSDI } from '@core/tsdi';
import { Api } from '@core/api';

export interface TeamMultiSelectProps {
    value: TeamSupportDto[];
    onChange: (value: TeamSupportDto[]) => void;
}

export const TeamMultiSelect: React.FC<TeamMultiSelectProps> = ({
    value,
    onChange
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [options, setOptions] = useState<TeamSupportDto[]>([]);
    const [loading, setLoading] = useState(false);
    const { challengeClient } = injectTSDI(Api);

    useEffect(() => {
        const fetchTeams = async () => {
            setLoading(true);
            try {
                // Replace with actual API call to fetch teams
                const response =
                    await challengeClient.support.teamSupportControllerGetPage({
                        search: searchTerm
                    });
                setOptions(response.data.content);
            } catch (error) {
                console.error('Error fetching teams:', error);
            } finally {
                setLoading(false);
            }
        };

        const timerId = setTimeout(() => {
            if (searchTerm) {
                fetchTeams();
            }
        }, 500);

        return () => clearTimeout(timerId);
    }, [searchTerm]);

    return (
        <MultiCombobox
            label="Select Teams"
            placeholder="Search teams..."
            searchPlaceholder="Search teams..."
            options={options}
            getOptionLabel={(option) => option.name || 'Unnamed Team'}
            getOptionKey={(option) => option.id}
            value={value}
            onChange={onChange}
            onInputChange={setSearchTerm}
            loading={loading}
            renderOption={(option) => (
                <div>
                    <p className="text-sm font-semibold">{option.name}</p>
                    <p className="text-xs text-muted-foreground">
                        Community: {option.community.name}
                    </p>
                    {option.community.tenantId !== undefined && (
                        <p className="text-xs text-muted-foreground">
                            Tenant: {option.community.tenantId}
                        </p>
                    )}
                </div>
            )}
        />
    );
};
